import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import apps from "../../apps.json";

const styles = {
    container: {
        height: "90%",
    },
    iframe: {
        width: "100%",
        height: "130%",
        border: "none",
    },
};

/**
 *
 * @param {*} appId
 * @param {*} path
 */
const getAppMeta = (appId) => {
    let app = apps.find((app) => app.id === appId);
    return app;
};

const getAppPath = (path, appId) => {
    path = path.replace(`/portal/app/${appId}`, "");
    return path;
};

const IFrameApp = (props) => {
    const { appId } = useParams();

    const loc = useLocation();
    const path = getAppPath(loc.pathname, appId);

    const [url, setUrl] = useState();

    const iframeRef = useRef(null);

    const app = getAppMeta(appId);

    useEffect(() => {
        const url = window.env[app.env_id];
        // Note: At some point we'll need a hash based URL
        // Method #1:
        //setUrl(`${url}${path}`);
        // Method #2
        setUrl(`${url}/#${path}`);
    }, [appId, path]);

    const handleIframeLoad = () => {
        window.myFrames = window.myFrames || {};
        window.myFrames[appId] = iframeRef.current;

        const user = JSON.parse(localStorage.getItem("user"));
        user.token = localStorage.getItem("token");

        iframeRef.current.contentWindow.postMessage(
            {
                channel: "LV_EVENT",
                type: "AUTH_USER",
                payload: {
                    user,
                },
            },
            "*"
        );
    };

    return (
        <div style={styles.container}>
            {url && <iframe ref={iframeRef} src={url} style={styles.iframe} onLoad={handleIframeLoad}></iframe>}
        </div>
    );
};
export default IFrameApp;
